


export const Cardhero = () => {
  return (
    <section>
      <div className="card_hero_container">
        <h1 className="card_hero_title">Popular Developer Tools</h1>
        <div className="card_text_container">
          <p className="card_hero_text">Get inspired by others to make web development easy!</p>
        </div>
      </div>
    </section>
  )
}

export default Cardhero;